import axios from "axios"

export default {
  findBy: (barcode, operatedAt) => axios.get(`/api/agreements?barcode=${barcode}&operatedAt=${operatedAt}`).then(({data}) => data)
}
